// Shared utility for formatting issue type names consistently across the application

export function formatIssueTypeName(type: string): string {
  // Convert UPPER_SNAKE_CASE or lower_snake_case to Title Case
  return type
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

// Map of issue types with their descriptions
export const ISSUE_DESCRIPTIONS: Record<string, string> = {
  HARDCODED_SALESFORCE_IDS: 'Flows contain hardcoded record or user IDs',
  DML_OPERATIONS_IN_LOOPS: 'Database operations inside loops',
  QUERIES_IN_LOOPS: 'SOQL queries inside loop structures',
  NOT_BULKIFIED: 'Flow processes single records instead of collections',
  NON_INDEXED_QUERY: 'Queries on non-indexed fields',
  UNFILTERED_QUERY: 'Queries without filter conditions',
  PERFORMANCE_ISSUES: 'General performance problems',
  NO_BULKIFICATION: 'Missing bulk processing patterns',
  MISSING_ERROR_HANDLING: 'Flows lack proper error handling paths',
  MISSING_DESCRIPTION: 'Flows without descriptions',
  HIGH_COMPLEXITY: 'Flows with excessive complexity',
  POOR_NAMING_CONVENTION: 'Flows with unclear naming'
};

// High severity issue types
export const HIGH_SEVERITY_ISSUES = [
  'DML_OPERATIONS_IN_LOOPS',
  'QUERIES_IN_LOOPS',
  'HARDCODED_SALESFORCE_IDS',
  'PERFORMANCE_ISSUES',
  'NO_BULKIFICATION',
  'NOT_BULKIFIED',
  'NON_INDEXED_QUERY',
  'UNFILTERED_QUERY'
];